module.exports = __webpack_public_path__ + "static/media/KE.b4e06220.png";